import { Grid } from "@material-ui/core";
import { Container, useMediaQuery, createTheme, Box, Typography, } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import Header from "../content-component/Header";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const icon1 = imageBaseUrl + "International-Relation/IndiaPage/less.png";
const icon2 = imageBaseUrl + "International-Relation/IndiaPage/global.png";
const icon3 = imageBaseUrl + "International-Relation/IndiaPage/scholarship.png";
const icon4 = imageBaseUrl + "International-Relation/IndiaPage/course.png";
const icon5 = imageBaseUrl + "International-Relation/IndiaPage/cultural.png";

const StudyInIndia = () => {
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const largeScreen = createTheme({
    breakpoints: {
      values: {
        xxl: 1920,
      },
    },
  });
  const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isSmScreen ? 1 : 5,
    slidesToScroll: 3,
    arrows: isMediumScreen ? true : isSmScreen ? true : false,
    autoPlay: true,
    autoplaySpeed: 500,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const StudyCardData = [
    {
      id: 1,
      icon: icon1,
      //   title: "Excellence",
      about: "Up to 70% Less Costly Than Europe/US",
    },
    {
      id: 2,
      icon: icon2,
      //   title: "Integrity",
      about: "1,100+ Globally recognized Universities & 42,000+ Colleges ",
    },
    {
      id: 3,
      icon: icon3,
      //   title: "Student-Centric Approach",
      about:
        "Up to 100% scholarships on tuition fees for international students",
    },
    {
      id: 4,
      icon: icon4,
      //   title: "Global Citizenship",
      about: "2,500+ Courses – Wide-ranging programs across disciplines.",
    },
    {
      id: 5,
      icon: icon5,
      //   title: "Global Citizenship",
      about:
        "50,000+ International Students – From 160+ countries, ensuring cultural diversity.",
    },
  ];
  return (
    <Container
      sx={{
        padding: "50px 0",
        height: "auto",
        width: "100%",
      }}
      maxWidth={isLargeScreen ? "xl" : "lg"}
    >
      <Grid
        container
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        direction="column"
      >
        {" "}
        <Header
          color="#00999e"
          textAlign="center"
          content="Why study in INDIA ?"
          sx={{ mb: 3 }}
        />
        <Container
          style={{
            height: "100%",
            // padding: "60px 0",
            justifyContent: isSmScreen
              ? "center"
              : isMediumScreen
              ? "center"
              : "space-between",
            alignItems: "center",
          }}
          maxWidth={isLargeScreen ? "xl" : "auto"}
        >
          <div
            style={{
              gap: "2rem",
              justifyContent: "center",
              margin: "auto",
            }}
          >
            {" "}
            <Slider {...settings}>
              {StudyCardData.map((card) => (
                <Grid item xs={12} sm={10} md={10} >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    p: 2,
                    borderRadius: "8px",
                    transition: "0.3s",
                    backgroundColor: "#f8f8f8",
                    "&:hover": {
                      backgroundColor: "#00999E",
                      color: "white",
                    },
                     height: "270px"
                  }}
                >
                  <img src={card.icon} alt="" style={{ width: 50, height: 50, marginBottom: 10, marginTop: 10 }} />
                  <Typography variant="body1" style={{ marginTop: 20 }}>{card.about}</Typography>
                </Box>
              </Grid>
              ))}
            </Slider>
          </div>
        </Container>
      </Grid>
    </Container>
  );
};

export default StudyInIndia;
